import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=7566e837&scoped=true"
import script from "./PreviewImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=7566e837&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7566e837",
  null
  
)

export default component.exports